import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, retry, throwError } from 'rxjs';
import * as moment from 'moment';
import * as jwt_decode from 'jwt-decode';
import { handleError } from '../utils/erro-handler';
import { getApiUrl } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {


  readonly BASE_URL = getApiUrl()
  readonly LORING_URL = "users/login"
  constructor(private http: HttpClient) { }



  login(user_cridentials) {
    return this.http.post(`${this.BASE_URL}/${this.LORING_URL}/`, user_cridentials)
      .pipe(
        catchError(handleError)
      );
  }

  saveToken(token, expire_at) {
    this.logout()
    localStorage.setItem("expire_at", expire_at)
    localStorage.setItem("token", token)

  }
  getToken() {
    return localStorage.getItem("token")
  }

  logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("expire_at")
  }

  public isLoggedIn() {
    if (this.getToken() !='' && moment().isBefore(this.getExpiration())) {
      return true
    }
    console.warn("isLoggedIn returned False", moment().isBefore(this.getExpiration()))
    return false;
  }

  isLoggedOut() {
    return !this.isLoggedIn();
  }

  getExpiration() {
    const expiration = localStorage.getItem("expire_at");
    return moment(expiration);
  }

  getUsername() {
    const decoded_token = jwt_decode.jwtDecode(this.getToken())
    return decoded_token["sub"]
  }
}
